import Tenant from './tenant';
import User from './user';

export default class PartnerCustomerStats {
  newTenant?: Tenant;

  mgmtLicenseCount: number;

  userCount: number;

  userLogins: User[];

  constructor() {
    this.userCount = 0;
    this.mgmtLicenseCount = 0;
    this.userLogins = [];
  }
}
